﻿import { ConfiguratorDI, Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObject } from "@models/configurators/kb-object";
import { PartMaterial } from "@models/configurators/part-material";
import { PartOperation } from "@models/configurators/part-operation";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IDummyNode } from "@models/configurators/kb-object";
import { UiObject } from "@models/configurators/ui-object";
import { IMethodOfManufacture } from "@models/entity-models";
import { PartRev } from "@models/configurators/partrev";
import { BistrackPartRev } from "@models/configurators/bistrack-partrev";
import { RuleContainer } from "@models/configurators/rule-container";
import { eRuleType } from "@models/enums";

@Kbo(CToken.MethodOfManufacture)
export class MethodOfManufacture extends RuleContainer implements IMethodOfManufacture {

    public rootPartRev: PartRev;
    public company: string;
    public isDefault: boolean;

    public $rulesNode: IDummyNode;

    constructor(kom: KbObjectManager) {
        super(kom);
        this.rootPartRev = new PartRev(kom, { partNum: "Part Revision" });
        this.ruleType = eRuleType.manufacture;
        this.company = null;
        this.isDefault = false;
        this.$rulesNode = { id: this.id + "_rules", $type: "RulesNode", allowedChildren: () => [CToken.Rule], getParent: () => this };
    }
}

@Kbo(CToken.BistrackMethodOfManufacture)
export class BistrackMethodOfManufacture extends RuleContainer implements IMethodOfManufacture {

    public rootPartRev: BistrackPartRev;

    public $rulesNode: IDummyNode;

    constructor(kom: KbObjectManager) {
        super(kom);
        this.rootPartRev = new BistrackPartRev(kom, { partNum: "Part Revision" });
        this.ruleType = eRuleType.bistrackManufacture;
        this.$rulesNode = { id: this.id + "_rules", $type: "RulesNode", allowedChildren: () => [CToken.Rule], getParent: () => this };
    }
}